module.exports = __webpack_public_path__ + "static/media/unlink.6feb8282.svg";